export const getGeniallyEmbedUrl = (url = "") => {
    const trimmed = url.trim();
    if (!trimmed)
        return "";

    const appViewMatch = trimmed.match(/app\.genially\.com\/view\/([^/?#]+)/i);
    if (appViewMatch)
        return `https://view.genially.com/${appViewMatch[1]}`;

    if (/view\.genially\.com/i.test(trimmed))
        return trimmed.split("?")[0];

    return trimmed;
};
